<template>
	<div class="card card-body card-banner-container mb-4" :class="{ edit: isFormEdit }">
		<div v-if="isFormCreate" class="d-flex card-banner-header">
			<button class="btn btn-sm btn-plain">
				<i class="bi-plus-circle"></i>
			</button>
			<span class="banner-title align-self-center mr-auto">{{ formTitle }}</span>
		</div>

		<div class="mt-2 p-3">
			<div class="form-group">
				<label for="title">Judul Banner</label>
				<input
					type="text"
					class="form-control"
					v-model="title"
					id="title"
					placeholder="Judul banner"
					required
				/>
			</div>

			<div class="form-group">
				<label for="url">Link To</label>
				<input
					type="text"
					class="form-control"
					v-model="url"
					id="url"
					placeholder="Input url for banner"
					required
				/>
			</div>

			<div class="row">
				<div class="col-md-6">
					<div class="form-group">
						<label for="image">Upload Banner Promosi Desktop</label>

						<button
							v-if="previewImageDesktop !== ''"
							class="btn btn-sm btn-plain text-danger"
							@click="previewImageDesktop = ''"
						>
							<i class="bi-x-circle"></i> Remove Image
						</button>

						<div
							v-if="previewImageDesktop !== ''"
							class="my-2 text-center preview-image"
						>
							<img
								class="img-fluid rounded"
								:src="previewImageDesktop"
								alt="Uploaded Image"
							/>
						</div>

						<div
							v-if="isUploadingDesktop && previewImageDesktop === ''"
							class="pc-image-empty"
						>
							<div class="image-loading">
								<div class="is-loading"></div>
							</div>
						</div>

						<div
							v-else-if="previewImageDesktop === ''"
							class="pc-image-empty custom"
							@click="uploadImage('desktop_image')"
						>
							<div class="image-upload-placeholder">
								<i class="fi fi-rr-picture image-placeholder"></i>
								<div class="text-placeholder">Klik untuk upload.</div>
							</div>
						</div>

						<div class="pc-input-desc">
							Upload image dengan resolusi 1296x324px agar fit dengan ukuran banner.
						</div>
					</div>
				</div>

				<div class="col-md-6">
					<div class="form-group">
						<label for="image">Upload Banner Promosi Mobile (optional)</label>

						<button
							v-if="previewImageMobile !== ''"
							class="btn btn-sm btn-plain text-danger"
							@click="previewImageMobile = ''"
						>
							<i class="bi-x-circle"></i> Remove Image
						</button>

						<div
							v-if="previewImageMobile !== ''"
							class="my-2 text-center preview-image"
						>
							<img
								class="img-fluid rounded"
								:src="previewImageMobile"
								alt="Uploaded Image"
							/>
						</div>

						<div
							v-if="isUploadingMobile && previewImageMobile === ''"
							class="pc-image-empty"
						>
							<div class="image-loading">
								<div class="is-loading"></div>
							</div>
						</div>

						<div
							v-else-if="previewImageMobile === ''"
							class="pc-image-empty custom"
							@click="uploadImage('mobile_image')"
						>
							<div class="image-upload-placeholder">
								<i class="fi fi-rr-picture image-placeholder"></i>
								<div class="text-placeholder">Klik untuk upload.</div>
							</div>
						</div>

						<div class="pc-input-desc">
							Upload image dengan resolusi 1518x759px agar fit dengan ukuran banner.
						</div>
					</div>
				</div>
			</div>

			<div class="form-group buttons m-0 hidden">
				<input
					type="file"
					accept="image/*"
					class="input-file"
					ref="imageUploader"
					id="pc-product-images-file"
					@change="onInputImageChange"
					multiple
				/>
				<label
					for="pc-product-images-file"
					class="btn btn-primary"
					:class="{ 'is-loading': isFetching }"
				>
					Upload images
				</label>
				<div class="pc-input-desc">Make sure your image resolution is 1296x324 px</div>
			</div>

			<div class="mt-3 pull-right">
				<button
					type="button"
					class="btn-outline o-md outline-primary mr-2"
					@click="handleCancelForm"
				>
					Cancel
				</button>

				<button
					type="button"
					class="btn-outline o-md outline-primary active"
					:class="{ 'is-loading': isFetching }"
					:disabled="isFetching"
					@click="submitBanner"
				>
					{{ submitLabel }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import mediaApi from '@/api/media';
import { getAxiosErrorMessage } from '@/lib/helper';
import { createWholesaleBanner, updateWholesaleBanner } from '@/api/admin';

export default {
	props: {
		formType: {
			type: String,
			default: 'create',
		},
		banner: {
			type: Object,
			default: () => ({}),
		},
		selectedId: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			title: '',
			url: '',
			imageDesktop: '',
			previewImageDesktop: '',
			isUploadingDesktop: false,
			imageMobile: '',
			previewImageMobile: '',
			isUploadingMobile: false,
			stateUpload: 'desktop_image',
			isFetching: false,
		};
	},
	computed: {
		isFormCreate() {
			return this.formType === 'create';
		},
		isFormEdit() {
			return this.formType === 'edit';
		},
		submitLabel() {
			return this.isFormCreate ? 'Submit' : 'Update';
		},
		formTitle() {
			return this.isFormCreate ? 'Buat Banner Baru' : 'Edit Banner';
		},
	},
	methods: {
		handleCancelForm() {
			if (this.isFormCreate) {
				this.$emit('on-cancel-create', false);
			} else if (this.isFormEdit) {
				this.$emit('on-cancel-edit', false);
			}
		},
		uploadImage(state) {
			this.stateUpload = state;
			const inputFile = this.$refs.imageUploader;
			inputFile.click();
		},
		onInputImageChange(event) {
			if (this.stateUpload === 'desktop_image') {
				this.imageDesktop = '';
				this.previewImageDesktop = '';
				this.isUploadingDesktop = true;
			} else if (this.stateUpload === 'mobile_image') {
				this.imageMobile = '';
				this.previewImageMobile = '';
				this.isUploadingMobile = true;
			}
			const maxUploadSize = 3; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 3MB)`;
					this.$notify({
						group: 'admin-sliders',
						text: noticeMessage,
						type: 'warn',
					});
					this.isUploadingDesktop = false;
					this.isUploadingMobile = false;
					break;
				}

				// Start Upload
				const uploadParams = new FormData();
				uploadParams.append('image', image);

				const callback = (response) => {
					const path = response.data;
					const url = `${this.mediaUrlPrefix}/${path}`;

					if (this.stateUpload === 'desktop_image') {
						this.imageDesktop = url;
						this.previewImageDesktop = url;
						this.isUploadingDesktop = false;
					} else if (this.stateUpload === 'mobile_image') {
						this.imageMobile = url;
						this.previewImageMobile = url;
						this.isUploadingMobile = false;
					}
				};

				const errorCallback = (e) => {
					if (this.stateUpload === 'desktop_image') {
						this.isUploadingDesktop = false;
					} else if (this.stateUpload === 'mobile_image') {
						this.isUploadingMobile = false;
					}

					this.$notify({
						group: 'admin-sliders',
						title: 'Upload Banner Wholesale',
						text: 'Failed to upload image',
						type: 'error',
					});
					console.log(e);
				};

				// Upload Image
				mediaApi.uploadImage(uploadParams, callback, errorCallback);
			}
			event.target.files = '';
			event.target.value = '';
		},
		submitBanner() {
			if (this.isFormCreate) {
				this.createBanner();
			} else if (this.isFormEdit) {
				this.editBanner();
			}
		},
		createBanner() {
			if (this.title === '' || this.imageDesktop === '' || this.url === '') {
				this.$notify({
					group: 'admin-sliders',
					title: 'Create Banner Wholesale',
					text: 'Semua inputan harus diisi.',
					type: 'error',
				});
			} else {
				this.isFetching = true;
				const params = {
					title: this.title,
					image: this.imageDesktop,
					image_mobile: this.imageMobile,
					url: this.url,
				};

				const callback = (response) => {
					// const banners = response.data;
					const message = response.message;
					this.$notify({
						group: 'admin-sliders',
						title: 'Create Banner Wholesale',
						text: message,
						type: 'success',
					});
					this.title = '';
					this.imageDesktop = '';
					this.imageMobile = '';
					this.url = '';
					this.previewImageDesktop = '';
					this.previewImageMobile = '';
					this.isFetching = false;

					this.$emit('on-success-submit', this.formType);
				};

				const errorCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'admin-sliders',
						title: 'Create Banner Wholesale',
						text: message,
						type: 'error',
					});
					this.isFetching = false;
				};

				createWholesaleBanner(params, callback, errorCallback);
			}
		},
		editBanner() {
			if (this.title === '' || this.imageDesktop === '' || this.url === '') {
				this.$notify({
					group: 'admin-sliders',
					title: 'Edit Banner Wholesale',
					text: 'Semua inputan harus diisi.',
					type: 'error',
				});
			} else {
				this.isFetching = true;
				const params = {
					title: this.title,
					image: this.imageDesktop,
					image_mobile: this.imageMobile,
					url: this.url,
				};

				const callback = (response) => {
					// const banners = response.data;
					const message = response.message;
					this.$notify({
						group: 'admin-sliders',
						title: 'Edit Banner Wholesale',
						text: message,
						type: 'success',
					});
					this.isFetching = false;

					this.$emit('on-success-submit', this.formType);
				};

				const errorCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'admin-sliders',
						title: 'Edit Banner Wholesale',
						text: message,
						type: 'error',
					});
					this.isFetching = false;
				};

				updateWholesaleBanner(this.selectedId, params, callback, errorCallback);
			}
		},
	},
	mounted() {
		if (this.isFormEdit) {
			this.title = this.banner.title;
			this.url = this.banner.url;
			this.imageDesktop = this.banner.image;
			this.previewImageDesktop = this.banner.image;
			this.imageMobile = this.banner.image_mobile;
			this.previewImageMobile = this.banner.image_mobile;
		}
	},
};
</script>

<style scoped lang="scss">
.card-banner-container {
	border: 2px solid #4d4d4d;
	border-radius: 10px;

	&.edit {
		border: none;
		margin-top: 2px;
	}

	.banner-title {
		font-weight: 700;
		font-size: 22px;
		line-height: 120%;
	}

	.drag-item {
		font-weight: 700;
		font-size: 16px;
	}

	label {
		font-weight: 700;
		font-size: 16px;
		line-height: 150%;
	}

	.form-control {
		border: 2px solid #1f1f1f61;
		height: calc(2.3em + 0.75rem + 2px);
	}
}

.pc-image-empty {
	&.custom {
		aspect-ratio: 1;
		max-height: 350px;
		cursor: pointer;
	}
}
</style>
